<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="企业名称："
        prop="vendorName">
        <el-input v-model="info.vendorName"></el-input>
      </el-form-item>
      <el-form-item
        label="企业账号（手机号）："
        prop="adminAccount">
        <span v-if="info.vendorId">{{ info.adminAccount }}</span>
        <el-input
          v-else
          v-model="info.adminAccount"></el-input>
      </el-form-item>
      <el-form-item
        label="信用代码："
        prop="unifiedCreditCode">
        <el-input v-model="info.unifiedCreditCode"></el-input>
      </el-form-item>
      <el-form-item
        label="营业执照："
        prop="businessLicenceFile">
        <upload-with-crop
          v-model="info.businessLicenceFile"
          :isLt2M="2048"
          :fixedNumber="[8,5]"
          :autoCropWidth="320"
          :autoCropHeight="200"></upload-with-crop>
        <!-- <el-input v-model="info.businessLicenceFile"></el-input> -->
      </el-form-item>
      <el-form-item
        label="省市区："
        prop="area">
        <area-select v-model="info.area"></area-select>
      </el-form-item>
      <el-form-item
        label="详细地址："
        prop="vendorAddress">
        <el-input
          v-model="info.vendorAddress"
          type="textarea"
          :rows="2"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人："
        prop="vendorPerson">
        <el-input v-model="info.vendorPerson"></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话："
        prop="vendorPhone">
        <el-input v-model="info.vendorPhone"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消 </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"> 确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import AreaSelect from '../sample-address/area-select'
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
export default {
  name: 'EditVendorModal',
  components: { AreaSelect, UploadWithCrop },
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: { vendorId: null, vendorName: '', adminAccount: '', unifiedCreditCode: '', businessLicenceFile: [], area: [], vendorAddress: '', vendorPerson: '', vendorPhone: '' },
      rules: {
        vendorName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 35, message: '企业名称长度最多 35 个字符', trigger: 'blur' }
        ],
        adminAccount: [
          { required: true, message: '请输入企业账号（手机号）', trigger: 'blur' }
        ],
        businessLicenceFile: [
          { required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
        unifiedCreditCode: [
          { required: true, message: '请输入信用代码', trigger: 'blur' }
        ],
        vendorPerson: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { max: 15, message: '联系姓名长度最多 15 个字符', trigger: 'blur' }
        ],
        vendorPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { pattern: /^1[0-9][0-9]\d{8}$/, message: '请输入正确的联系人电话', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择省市区', trigger: 'blur' }
        ],
        vendorAddress: [
          { required: true, message: '请输入企业地址', trigger: 'blur' },
          { max: 50, message: '企业地址长度最多 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const vendorId = this.info.vendorId
      return (vendorId ? '编辑' : '新增') + '企业'
    },
    provinceCode() {
      return this.info.area[0] || null
    },
    cityCode() {
      return this.info.area[1] || null
    },
    areaCode() {
      return this.info.area[2] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = { vendorId: null, vendorName: '', unifiedCreditCode: '', businessLicenceFile: [], area: [], vendorAddress: '', vendorPerson: '', vendorPhone: '' }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.vendorId ? 'updatevendor' : 'addvendor'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              provinceCode: this.provinceCode,
              cityCode: this.cityCode,
              areaCode: this.areaCode,
              businessLicenceFile: this.info.businessLicenceFile.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      // this.info.parentSgsId = parentSgsId
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = { ...this.info, ...options }
      this.toggleModal(true)
    }
  }
}
</script>
